import React, { useRef } from 'react';

/**
 * Renders a div with some content, and automatically hides the title unless
 * the content overflows.
 */
const AutoTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const overflowing = containerRef.current
    ? containerRef.current.scrollWidth > containerRef.current.offsetWidth
    : false;

  const { title, ...rest } = props;

  return <div title={overflowing ? title : undefined} {...rest} />;
};

export default AutoTitle;
